module.exports = __webpack_public_path__ + "static/media/seperator.8177a28d.svg";